export { default as Logo } from './src/logo.vue';
